module.exports = __webpack_public_path__ + "static/media/layer1.6d7ac50a.svg";